export const SheetIcon = ({ ...rest }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="#7C3AED"
        fillOpacity="0.1"
      />
      <path
        d="M22.5 11.6667H15C14.558 11.6667 14.1341 11.8423 13.8215 12.1548C13.5089 12.4674 13.3333 12.8913 13.3333 13.3333V26.6667C13.3333 27.1087 13.5089 27.5326 13.8215 27.8452C14.1341 28.1577 14.558 28.3333 15 28.3333H25C25.442 28.3333 25.866 28.1577 26.1785 27.8452C26.4911 27.5326 26.6667 27.1087 26.6667 26.6667V15.8333L22.5 11.6667Z"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.6667 11.6667V15C21.6667 15.442 21.8423 15.8659 22.1548 16.1785C22.4674 16.4911 22.8913 16.6667 23.3333 16.6667H26.6667"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 17.5H16.6667"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3333 20.8333H16.6667"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.3333 24.1667H16.6667"
        stroke="#7C3AED"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
